import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-download\"><path d=\"M8.31 13.004A1.128 1.128 0 0 0 9.79 13l6.68-5.843a1.13 1.13 0 0 0-1.486-1.7l-4.809 4.205V2.22a1.129 1.129 0 0 0-2.257 0v7.461l-4.91-4.231a1.13 1.13 0 0 0-1.474 1.71l6.774 5.843Zm7.417 1.688H2.273a1.129 1.129 0 1 0-.002 2.257h13.456a1.129 1.129 0 0 0 0-2.257Z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol